module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-ThIt.6af5432.woff2";